import { defineStore }              from 'pinia';
import { useStorage }               from '@vueuse/core';
import * as jose                    from 'jose';
import { registerUser, reset }      from '@/plugins/Posthog';
import { setUser as sentrySetUser } from '@sentry/vue';
import Service                      from '@/api/service';

export const useUserStore = defineStore('user', {
  state   : () => ({
    token               : useStorage('token', ''),
    tenant              : useStorage('tenant', ''),
    user                : useStorage('user', {}),
    redirectedUrl       : useStorage('redirectedUrl', {}),
    hasAccess           : useStorage('hasAccess', false),
    currentUser         : useStorage('currentUser', {}),
    overrideRoles       : useStorage('overrideRoles', {}),
    isEditing           : 0,
    navigationLocked    : false,
    showNavigationAlert : false
  }),
  actions : {
    async setToken(token) {

      this.token = token;
      if (token && token !== '') {

        await this.setUser(jose.decodeJwt(token));
      }
    },
    setTenant(tenant) {

      this.tenant = tenant;
    },
    async setUser(user) {

      if (user.tenantId && user.id) {
        //get user from bdd because token does not have all data needed for Posthog
        this.user = await Service.getUser(user.tenantId, user.id);
        registerUser(this.user);
        this.setHasAccess(true);
        sentrySetUser({ id : user.id, email : user.email, username : `${user.firstName} ${user.lastName}` });
      } else {

        this.user = user;
        reset();
      }
    },
    setHasAccess(value) {

      this.hasAccess = value;
    },
    setCurrentUser(user) {

      this.currentUser = user;
    },
    checkLoginExpDate() {

      if (this.user?.exp && this.user?.exp < Date.now() / 1000) {

        this.logout();
      }
    },
    setRedirectUrl(urlObject) {

      this.redirectedUrl = urlObject;
    },
    setOverrideRoles(newRoles) {

      this.overrideRoles = newRoles;
    },
    setIsEditing(newIsEditing) {

      this.isEditing = newIsEditing;
    },
    setNavigationLocked(newNavigationLocked) {

      this.navigationLocked = newNavigationLocked;
    },
    setShowNavigationAlert(newShowNavigationAlert) {

      this.showNavigationAlert = newShowNavigationAlert;
    },
    logout() {

      // Déconnexion subie (401, session invalide) : on mémorise la page courante pour y revenir après le login
      const current = this.$router.currentRoute.value;

      if (current.name && !current.name.startsWith('login') && !current.name.startsWith('logout')) {

        this.setRedirectUrl({ name : current.name, params : current.params, query : current.query });
      }

      this.setToken('');
      this.setUser({});
      sentrySetUser(null);
      this.setHasAccess(false);
      this.$router.replace({ name : 'logout', params : { tenant : this.tenant } });
    }
  }
});
